import { render } from "./RoleDelete.vue?vue&type=template&id=53678676&ts=true"
import script from "./RoleDelete.vue?vue&type=script&lang=ts"
export * from "./RoleDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__